<template>
  <section id="schedule" class="schedule" v-if="Object.keys(events).length > 0">
    <h1>Raspored</h1>
    <section class="main">
      <div class="schedule-menu">
        <div class="schedule-day">
          <button class="schedule-day-button active" v-on:click="toggleDay(0)">14</button>
          <button class="schedule-day-button" v-on:click="toggleDay(1)">15</button>
        </div>
        <div class="schedule-type active0">
          <div class="schedule-type__button active" v-on:click="showScheduleContainer(0)">Predavanja i paneli</div>
          <div class="schedule-type__button" v-on:click="showScheduleContainer(1)">Radionice</div>
        </div>
      </div>

      <section class="schedule-container">
        <section class="schedule-item-container active">
          <template v-if="shownEvents.hasOwnProperty('Lecture') && shownEvents.Lecture.length">
            <template v-for="event in shownEvents.Lecture">
              <Event v-bind:event="event" v-bind:key="event.id" />
            </template>
          </template>
        </section>

        <section class="schedule-item-container">
          <template v-if="shownEvents.hasOwnProperty('Workshop') && shownEvents.Workshop.length">
            <template v-for="event in shownEvents.Workshop">
              <Event v-bind:event="event" v-bind:key="event.id" />
            </template>
          </template>
        </section>

        <section class="schedule-item-container">
          <template v-if="shownEvents.hasOwnProperty('JigsawSession') && shownEvents.JigsawSession.length">
            <template v-for="event in shownEvents.JigsawSession">
              <Event v-bind:event="event" v-bind:key="event.id" />
            </template>
          </template>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
import Event from '@/components/landing-page/Event.vue';

export default {
  name: 'EventList',
  data() {
    return {
      shownEvents: {},
    };
  },
  components: {
    Event,
  },
  computed: {
    events: function() {
      return this.$store.getters['landing/events'];
    },
  },
  methods: {
    getDistinctDays: function() {
      return this.$store.getters['landing/eventDistinctDays'];
    },
    getEvents: function() {
      return this.$store.getters['landing/events'];
    },
    toggleDay: function(dayNumber) {
      let buttons = document.querySelectorAll('.schedule-menu button');

      for (let button of buttons) button.classList.remove('active');
      buttons[dayNumber].classList.add('active');

      this.filterShownEvents(dayNumber);
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('scroll'));
      });
    },
    filterShownEvents: function(dayNumber) {
      for (let category in this.getEvents()) {
        this.shownEvents[category] = this.getEvents()[category].filter(
          event => new Date(event.starts).getDate() === this.getDistinctDays()[dayNumber],
        );
        this.$forceUpdate();
      }
    },
    showScheduleContainer: function(indexOfContainerToShow) {
      let scheduleItemContainers = document.querySelectorAll('.schedule-item-container');

      let scheduleTypeButtons = document.querySelectorAll('.schedule-type__button');

      let scheduleType = document.querySelector('.schedule-type');

      for (let i = 0; i < 3; i++) {
        if (i === indexOfContainerToShow) scheduleType.classList.add(`active${i}`);
        else scheduleType.classList.remove(`active${i}`);
      }

      scheduleTypeButtons.forEach((button, index) => {
        button.classList.remove('active');
        if (index === indexOfContainerToShow) button.classList.add('active');
      });

      for (let container of scheduleItemContainers) container.classList.remove('active');

      scheduleItemContainers[indexOfContainerToShow].classList.add('active');
      document.dispatchEvent(new CustomEvent('scroll'));
    },
  },
  mounted() {
    this.filterShownEvents(0);
  },
};
</script>

<style scoped>
.schedule {
  margin: 0 auto;
  max-width: 1030px;
}

section > h1 {
  margin-top: 100px;
  margin-bottom: 50px;
  color: #fff;
  font-weight: 800;
  line-height: 48px;
  font-size: 40px;
  text-align: center;
}

.main {
  display: flex;
  flex-direction: column;
}

.schedule-item-container {
  display: none;
}

.schedule-item-container .event-item {
  visibility: hidden;
}

.schedule-item-container.active {
  display: block;
}

.schedule-item-container.active .event-item {
  visibility: visible;
}

.schedule-container div.schedule-item:not(:first-of-type) {
  margin-top: 50px;
}

@media screen and (max-width: 1030px) {
  .schedule {
    margin: 0 16px;
  }
}
</style>
